import { createFileRoute } from "@tanstack/react-router";
import { ApexCardsDemoPage } from "@/features/demo/apex-cards-page";

export const Route = createFileRoute("/demo/apex-cards")({
  component: RouteComponent,
  head: () => ({
    meta: [{ name: "robots", content: "noindex,nofollow" }],
  }),
});

function RouteComponent() {
  return <ApexCardsDemoPage />;
}
